import Swiper from "swiper";

import { Navigation, Autoplay, FreeMode } from "swiper/modules";

document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".gallery-slider-block");

  blocks.forEach((block) => {
    const slider = block.querySelector(".swiper");
    if (!slider) return;

    const trail = slider.querySelector(".swiper-wrapper");
    const prev = slider.querySelector(".swiper-button-prev");
    const next = slider.querySelector(".swiper-button-next");

    const hasProp = (prop, obj) =>
      Object.keys(obj).filter((key) => key === prop).length > 0;

    // Create a variable for data-autoplay on .swiper, if it exists true, false otherwise
    const hasAutoplay = hasProp("autoplay", slider.dataset);
    const overflowHidden = slider.classList.contains("hide-trail");

    const slides = trail.querySelectorAll(".swiper-slide"); // TODO: Change for children of trail instead

    if (!trail || !slides.length) {
      console.warn("El contenedor Swiper no se encontró en:", block);
      return;
    }

    // Check if picture elements inside trail have .swiper-slide and .gallery-slider__card, otherwise add them before init swiper
    const addClasses = (element, classes) => {
      classes.forEach((cls) => {
        if (!element.classList.contains(cls)) {
          element.classList.add(cls);
        }
      });
    };

    slides.forEach((slide) => {
      addClasses(slide, ["swiper-slide", "gallery-slider__card"]);
    });

    const swiper = new Swiper(slider, {
      spaceBetween: 8,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: false,
      allowTouchMove: true,
      freeMode: {
        enabled: true,
        sticky: true,
        minimumVelocity: 0.05,
        momentum: true,
        momentumRatio: 0.5,
      },
      speed: 1200,
      navigation: {
        prevEl: prev,
        nextEl: next,
      },

      modules: [Navigation, Autoplay, FreeMode],
    });

    // Activa autoplay solo en pantallas mayores a 768px
    if (window.innerWidth >= 768 && hasAutoplay) {
      swiper.params.autoplay = {
        delay: 2000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      };
      swiper.autoplay.start();
      new IntersectionObserver((entries, observer) => {
        if (entries[0].isIntersecting) {
          swiper.autoplay.start();
        } else {
          swiper.autoplay.stop();
        }
      }).observe(block);
    }
  });
});
